<form [formGroup]="form()">
  <fino-input formControlName="name" label="name" validationIndicator> </fino-input>

  <fino-input formControlName="purpose" label="purpose" validationIndicator> </fino-input>

  <button
    type="submit"
    fino-button
    (click)="submit()"
    [disabled]="!isFormValid"
    [primary]="true"
    class="mb-3"
  >
    @if (isUpdateMode()) {
      <span translate="receivedPayments.update"></span>
    }
    @if (!isUpdateMode()) {
      <span translate="receivedPayments.add"></span>
    }
  </button>

  @if (hasReceivedPayments()) {
    <div class="columns" [formGroup]="searchForm">
      <div class="column is-8">
        <fino-input formControlName="search" class="mr-2" label="Suchen"> </fino-input>
      </div>
      <div class="column">
        <button class="mt-1 is-fullwidth" fino-button (click)="deleteAllItems()">
          <label class="mr-1" translate="receivedPayments.all"></label>
          <fino-icon icon="Bin 1"></fino-icon>
        </button>
      </div>
    </div>
  }

  @if (hasReceivedPayments()) {
    <div class="items-container">
      @for (recievedPayment of filteredReceivedPayments(); track recievedPayment) {
        <article [class.is-primary]="recievedPayment.selected" class="panel">
          <div class="panel-heading">
            <div class="columns">
              <div class="column">
                <p class="has-text-white">{{ recievedPayment.name }}</p>
              </div>
              <div class="column is-flex is-justify-content-flex-end">
                <fino-icon
                  icon="Pencil 2"
                  (click)="editItem(recievedPayment)"
                  class="has-text-white mr-3"
                ></fino-icon>
                <fino-icon
                  icon="Common File Double"
                  (click)="duplicateItem(recievedPayment)"
                  class="has-text-white mr-3"
                ></fino-icon>
                <fino-icon
                  icon="Bin 1"
                  (click)="deleteItem(recievedPayment, !recievedPayment.selected)"
                  class="has-text-white"
                ></fino-icon>
              </div>
            </div>
          </div>
          <div
            class="panel-block is-flex is-flex-direction-column is-align-items-flex-start"
            [class.has-text-grey-light]="!recievedPayment.selected"
          >
            <label
              ><span translate="receivedPayments.purpose"></span>
              <b>{{ recievedPayment.purpose }}</b></label
            >
          </div>
        </article>
      }
    </div>
  }
</form>
